module.exports = "/packs/images/svg/search_new~5da18ba72e96ebc7bfd743c7a317e489.svg";